<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">{{ field.question }}</label>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
		</div>
		<div :class="{'float-right': (field.labelStyle=='justify')}" v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':'') }">

			<select
				v-if="(field.selectType && field.selectType == 'dropdown')"
				:disabled="readonly"
				v-model="field.value"
				:id="field.id"
				:aria-label="field.question"
				class="form-control"
				>
				<option value="">{{$t('please-select')}}</option>
				<option
				v-for="(option, okey) in options"
				:key="okey"
				:value="option.value"
				:aria-label="`${field.question}: ${option.caption}`"
				>{{ option.caption }}</option>
			</select>

			<div
				:value="field.value"
				class="btn-group"
				:id="field.id"
				:aria-label="field.question"
				v-else
			>
				<button
				v-for="(option, okey) in options"
				:key="okey"
				class="btn"
				:class="getClassStr(option)"
				@click="field.value==option.value?field.value='':field.value=option.value"
				:value="option.value"
				:disabled="readonly"
				:aria-label="`${field.question}: ${option.caption}`"
				>{{ option.caption }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly'],
	methods: {
		getClassStr(option) {
			if(this.field.value == option.value) {
				if(option.cssclass) {
					return `btn-on ${option.cssclass}`;
				} else {
					return 'btn-on';
				}
			} else {
				return 'btn-off';
			}
		}
	},
	computed: {
		options() {
			if(this.field.optionsFromConfig) {
				const options = [];
				for(let option of this.$config.getValue(this.field.optionsFromConfig)) {
					options.push({
						value: option.id,
						caption: option.name
					})
				}
				return options;
			} else {
				return this.field.options;
			}
		}
	}
};
</script>
